import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"

export type BulkFormRemoveCellProps = Omit<ButtonProps, "onClick"> & {
  onRemove(): void
}

function BulkFormRemoveCell(props: BulkFormRemoveCellProps) {
  const { onRemove, ...buttonProps } = props

  return (
    <td>
      <Button
        type="button"
        variant="ghost"
        size="xs"
        iconSrc="cross-small"
        onClick={onRemove}
        {...buttonProps}
      />
    </td>
  )
}

export default BulkFormRemoveCell
